import React from 'react'
import { RouteComponentProps, Redirect } from '@reach/router'
import { getUserContainer } from 'container/user-module'
import { LOGGED_USER_SERVICE_KEY } from 'modules/users'
import { useUserRoles } from 'modules/users/hooks/useUserRoles'
import { ILoggedUserService } from 'modules/users/services/LoggedUserService'

const loggedUserService = getUserContainer().get<ILoggedUserService>(LOGGED_USER_SERVICE_KEY)

interface ProtectedRouteProps extends RouteComponentProps {
  component: React.ComponentType<any>
  canAccess: (userRoles: ReturnType<typeof useUserRoles>) => boolean
  [key: string]: any
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  component: Component,
  canAccess,
  ...rest
}) => {
  const user = loggedUserService.get()
  const userRoles = useUserRoles(user)

  if (!canAccess(userRoles)) {
    const redirectTo = userRoles.isFamiliar ? '/patients' : '/newsWall'
    return <Redirect to={redirectTo} noThrow />
  }

  return <Component {...rest} />
}
